import { RequestService } from '../../services/RequestService';
import { GET_IDENTITY_DOCUMENTS } from '../constants';

export const getIdentityDocuments = payload => {
  return RequestService.get(GET_IDENTITY_DOCUMENTS);
};
